module.exports = __webpack_public_path__ + "static/media/controls-basic.a383860d.png";